import React, {useState} from 'react';
import {useLocation} from 'react-router';
import classNames from 'classnames';
import {Brand} from '../../../../../_metronic/layout/components/brand/Brand';
import {checkIsActive, toAbsoluteUrl} from '../../../../../_metronic/_helpers';
import {ProtectedComponent} from '../Permissions';
import {FormattedMessage} from 'react-intl';
import {NavLink} from 'react-router-dom';
import NewInvoiceOrdersCount from '../NewInvoiceOrdersCount';
import styles from './styles.module.scss';

export default function Navigation() {
  const [show, setShow] = useState(false);
  const location = useLocation();
  const getMenuItemActive = (url, hasSubmenu = false) => {
    return checkIsActive(location, url)
      ? ` ${!hasSubmenu && 'menu-item-active'} menu-item-open menu-item-not-hightlighted`
      : '';
  };

  const asideList = [
    {
      key: 0,
      url: '/users',
      subject: 'usersPage',
      icon: '/media/svg/Group-brandColor.svg',
      label: 'usersList'
    },
    {
      key: 1,
      url: '/user/',
      subject: 'userPage',
      icon: '/media/svg/User-brandColor.svg',
      label: 'userDetails'
    },
    {
      key: 2,
      url: '/transfersByAgent/',
      subject: 'transfersByAgentPage',
      icon: '/media/svg/UserSwitch_brandColor.svg',
      label: 'transfersByAgent'
    },
    {
      key: 17,
      url: '/all-transfers',
      subject: 'transfersPage',
      icon: '/media/svg/Transfers_brandColor.svg',
      label: 'transfers'
    },
    {
      key: 3,
      url: '/invoices',
      subject: 'invoices',
      icon: '/media/svg/Dollar_brandColor.svg',
      label: 'invoices'
    },
    {
      key: 4,
      url: '/invoice-orders',
      subject: 'invoiceOrders',
      icon: '/media/svg/Box3_brandColor.svg',
      label: 'invoice-orders'
    },
    {
      key: 5,
      url: '/receipts',
      subject: 'receipts',
      icon: '/media/svg/Wallet3_brandColor.svg',
      label: 'receipts'
    },
    {
      key: 6,
      url: '/customers',
      subject: 'customersPage',
      icon: '/media/svg/Customers_brandColor.svg',
      label: 'customers'
    },
    {
      key: 7,
      url: '/automated-payments',
      subject: 'bituahLeumiPayment',
      icon: '/media/svg/Git4_brandColor.svg',
      label: 'automatedPayments'
    },
    {
      key: 8,
      url: '/registration-data',
      subject: 'registrationPage',
      icon: '/media/svg/Clipboard-list-brandColor.svg',
      label: 'registrationData'
    },
    {
      key: 9,
      url: '/complete-details',
      subject: 'completeDetails',
      icon: '/media/svg/Search_brandColor.svg',
      label: 'complete-details'
    },
    {
      key: 10,
      url: '/partners',
      subject: 'partners',
      icon: '/media/svg/Partners_brandColor.svg',
      label: 'partners'
    },
    {
      key: 11,
      url: '/invited-users',
      subject: 'invitedUsersPage',
      icon: '/media/svg/Add-user_brandColor.svg',
      label: 'invited-users'
    },
    {
      key: 12,
      url: '/agents-incomes',
      subject: 'agentsIncomePage',
      icon: '/media/svg/Book_brandColor.svg',
      label: 'agents-incomes'
    },
    {
      key: 13,
      url: '/projects',
      subject: 'projectsPage',
      icon: '/media/svg/Mail_brandColor.svg',
      label: 'projects'
    },
    {
      key: 14,
      url: '/unpaid-agents',
      subject: 'unpaidAgentsPage',
      icon: '/media/svg/Warning_brandColor.svg',
      label: 'unpaid-agents'
    },
    {
      key: 15,
      url: '/logs-users-actions',
      subject: 'usersActionsPage',
      icon: '/media/svg/Logs_brandColor.svg',
      label: 'users-actions'
    },
    {
      key: 151,
      url: '/logs-users-client-actions',
      subject: 'usersClientActionsPage',
      icon: '/media/svg/Logs_brandColor.svg',
      label: 'users-client-actions'
    },
    {
      key: 16,
      url: '/paypal-requests',
      subject: 'paypalRequestsPage',
      icon: '/media/svg/Paypal_brandColor.svg',
      label: 'paypal-requests'
    },
    {
      key: 18,
      url: '/bank-statements',
      subject: 'bankStatementsPage',
      icon: '/media/svg/Bank_brandColor.svg',
      label: 'bank-statements'
    },
    {
      key: 19,
      url: '/notifications-center',
      subject: 'notificationsPage',
      icon: '/media/svg/Notifications_brandColor.svg',
      label: 'notifications'
    },
    {
      key: 20,
      url: '/lawsuit',
      subject: 'lawPage',
      icon: '/media/svg/Law_brandColor.svg',
      label: 'law'
    },
    {
      key: 21,
      url: '/ai-reports',
      subject: 'aiReportsPage',
      icon: '/media/svg/AI_bc.svg',
      label: 'ai-reports'
    },
  ];

  const getContent = (item, index) => {
    switch (item.subject) {
      case 'userPage':
      case 'transfersByAgentPage':
        return (
          <>
            {getMenuItemActive(item.url, false) && (
              <li
                className={`menu-item ${getMenuItemActive(item.url, false)}`}
                key={index}
              >
                <ProtectedComponent action="view" subject={item.subject}>
                  <div className={classNames('menu-link', styles.menuLink)}>
                    <img
                      src={toAbsoluteUrl(item.icon)}
                      alt="icon"
                      className={styles.asideListIcon}
                    />
                    <span className={classNames('menu-text', styles.menuText)}>
                    <FormattedMessage
                      id={`mainMenu-item-${item.label}`}
                      defaultMessage={item.label}
                    />
                  </span>
                  </div>
                </ProtectedComponent>
              </li>
            )}
          </>
        );
      case 'invoiceOrders':
        return (
          <li
            className={`menu-item ${getMenuItemActive(item.url, false)}`}
            key={index}
          >
            <ProtectedComponent action="view" subject={item.subject}>
              <NavLink
                className={classNames(
                  'menu-link py-0 d-flex align-items-center',
                  styles.menuLink,
                )}
                to={item.url}
              >
                <img
                  src={toAbsoluteUrl(item.icon)}
                  alt="icon"
                  className={styles.asideListIcon}
                />
                <span className={classNames('menu-text', styles.menuText)}>
                    <FormattedMessage
                      id={`mainMenu-item-${item.label}`}
                      defaultMessage={item.label}
                    />
                  </span>
                <NewInvoiceOrdersCount/>
              </NavLink>
            </ProtectedComponent>
          </li>
        );
      default:
        return (
          <li
            className={`menu-item ${getMenuItemActive(item.url, false)}`}
            key={index}
          >
            <ProtectedComponent action="view" subject={item.subject}>
              <NavLink
                className={classNames(
                  'menu-link',
                  styles.menuLink
                )}
                to={item.url}
              >
                <img
                  src={toAbsoluteUrl(item.icon)}
                  alt="icon"
                  className={styles.asideListIcon}
                />
                <span className={classNames('menu-text', styles.menuText)}>
                <FormattedMessage
                  id={`mainMenu-item-${item.label}`}
                  defaultMessage={item.label}
                />
              </span>
              </NavLink>
            </ProtectedComponent>
          </li>
        );
    }
  };

  return (
    <div className={classNames(styles.aside)}>
      <div className={classNames(styles.buttonToggle, show ? styles.shown : styles.hidden)}>
        <img
          src={toAbsoluteUrl(show
            ? '/media/svg/ChevronDouble_right.svg'
            : '/media/svg/ChevronDouble_left.svg'
          )}
          alt="show"
          onClick={() => setShow(!show)}
          className={styles.icon}
        />
      </div>
      <div className={show ? styles.asideContentShow : styles.asideContentHide}>
        <Brand/>
        <div data-menu-vertical="1" className={classNames(`aside-menu my-4`, styles.asideMenu)}>
          <ul className={classNames('menu-nav', styles.menuNav)}>
            {asideList.map(getContent)}
          </ul>
        </div>
      </div>
    </div>
  );
}
